import React, { useState } from "react";

import { Box, makeStyles } from "@material-ui/core";

import { DrivingDetails, MyBusinessCard, PersonalDetails } from "./components";
import { FormPageActions } from "@hubcapp/components";
import { MyDetailsProps } from "./types";
import { Tab, Tabs } from "@material-ui/core";
import { TabContext, TabPanel } from "@material-ui/lab";
import Content from "@ds-developer/content";
import MyDocuments from "./MyDocuments";
import PageHeader from "@ds-developer/page-header";

const useStyles = makeStyles(theme => ({
  detailsWrapper: {
    [theme.breakpoints.down("sm")]: {
      marginTop: "24px",
    },
  },
}));

const MyDetails: React.FC<MyDetailsProps> = ({
  personId,
  name,
  franFreeDaysBalance,
  dateOfBirth,
  address,
  emailAddress,
  mobileNumber,
  landlineNumber = "",
  certifications,
  propositions,
  additionalDrivers,
  loading = false,
  updateLoading = false,
  documentsByInstructor,
  onSubmit = () => {},
  onDiscardClick = () => {},
  onMileageUpdate = () => {},
  refetchDocs,
  instructorId,
  customerAndFranchiseDocumentsByPerson,
}) => {
  const [value, setValue] = useState(
    location.hash === "#documents" ? "documents" : "myDetails",
  );

  const handleChangeTab = (event: any, newValue: string) => {
    setValue(newValue);
  };

  const classes = useStyles();

  return (
    <Content>
      <PageHeader
        title="My details"
        breadcrumbs={[{ title: "Home", link: "/" }, { title: "My details" }]}
      />
      <Tabs
        value={value}
        onChange={handleChangeTab}
        variant="scrollable"
        textColor="primary"
      >
        <Tab value="myDetails" label="My details"></Tab>
        <Tab value="documents" label="Documents"></Tab>
      </Tabs>
      <TabContext value={value}>
        <TabPanel value="myDetails">
          <form onSubmit={onSubmit}>
            <Box mb={3} className={classes.detailsWrapper}>
              <PersonalDetails
                name={name}
                dateOfBirth={dateOfBirth}
                address={address}
                emailAddress={emailAddress}
                mobileNumber={mobileNumber}
                landlineNumber={landlineNumber}
                personId={personId}
                loading={loading}
              />
            </Box>

            <Box mb={3}>
              <DrivingDetails
                onMileageUpdate={onMileageUpdate}
                additionalDrivers={additionalDrivers}
                certifications={certifications}
                loading={loading}
              />
            </Box>

            <MyBusinessCard
              propositions={propositions}
              franFreeDaysBalance={franFreeDaysBalance ?? 0}
              loading={loading}
            />

            <Box marginY={5}>
              <FormPageActions
                loading={updateLoading}
                submitDisabled
                discardDisabled
                onDiscardClick={onDiscardClick}
              />
            </Box>
          </form>
        </TabPanel>
        <TabPanel value="documents">
          <MyDocuments
            refetchDocs={refetchDocs}
            documents={documentsByInstructor}
            instructorId={instructorId}
            loading={loading}
            customerAndFranchiseDocumentsByPerson={
              customerAndFranchiseDocumentsByPerson
            }
          ></MyDocuments>
        </TabPanel>
      </TabContext>
    </Content>
  );
};

export default MyDetails;
